import request from "@/utils/request";

// 白名单

// 查看充电白名单
export const getLocalAuthList = params => {
	return request({
		url: "/localAuthList",
		method: "GET",
		params,
	});
};

// 添加删除白名单
export const setLocalAuthList = data => {
	return request({
		url: "/localAuthList",
		method: "POST",
		data,
	});
};

// 推送充电白名单
export const sendLocalAuthList = data => {
	return request({
		url: "/send/localAuthList",
		method: "POST",
		data,
	});
};

// 推送充电白名单的soc限制
export const sendLocalAuthLimit = data => {
	return request({
		url: "/send/localAuthLimit",
		method: "POST",
		data,
	});
};
